<template>
  <div class="list">
    <notifications></notifications>
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
            ></head-menu-filter>

            <div class="row mb-2">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters['nachname']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.surname') }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters['vorname']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.firstname') }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters['loginName']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.loginname') }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div
                      class="form-group"
                      id="number-of-records"
                    >
                      <input
                        v-model="filters.count"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.numberofrecords') }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="navbarTitel"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row mt-2 d-flex justify-content-between">
                  <div class="ml-4 mr-2">
                    <router-link
                      v-if="isAdmin"
                      class="btn btn-success mr-2"
                      :to="{ name: 'benutzer', params: { id: null, anzeige: 0 } }"
                    >
                      <font-awesome-icon icon="fa-solid fa-plus" class="mr-2" />
                      <span>{{ $t('global.new') }}</span>
                    </router-link>
                  </div>
                  <div class="mr-4">
                    <button
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                      v-if="isAdmin"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-2"
                      />
                      <span>{{ $t('global.delete') }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    sort-icon-left
                    no-local-sorting
                    @sort-changed="sortingChanged"
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template
                      slot="top-row"
                      slot-scope="{ fields }"
                    >
                      <td
                        class="no-pointer"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <b-input
                          v-if="
                            field.key != 'selected' &&
                            field.searchable !== false
                          "
                          size="sm"
                          v-model="filters[field.key]"
                          :placeholder="field.label"
                          autocomplete="off"
                        />
                      </td>
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        v-model="header.selected"
                        @input="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>

                    <template #table-busy>
                      <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </template>

                    <template #empty>
                      <div
                        v-if="ladeFehler"
                        class="text-center text-danger my-2"
                      >
                        <strong>{{ $t('global.errorwhileloading') }}</strong>
                      </div>
                      <div
                        v-if="!ladeFehler"
                        class="text-center text-primary my-2"
                      >
                        <strong>{{ $t('global.nodataavailable') }}</strong>
                      </div>
                    </template>
                  </b-table>
                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="(state) => infiniteHandler(state, 'app-api')"
                  >
                    <div slot="spinner">{{ $t('global.loadmoredata') }}</div>
                    <div slot="no-more">{{ $t('global.nofurtherdata') }}</div>
                    <div slot="no-results">
                      {{ $t('global.nofurtherdatafound') }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loeschen-modal
      id="benutzer-loeschen-modal"
      @confirmed="loeschen"
      :multiple="true"
    />

    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
  import Api from '@/api/AppApi'

  import HeadMenu from '@/components/HeadMenu'
  import HeadMenuFilter from '@/components/HeadMenuFilter'
  import Navbar from '@/components/Navbar'
  import LoeschenModal from '@/components/Modals/LoeschenModal'
  import store from '@/store'
  import page from '@/mixins/Page'
  import dashboard from '@/mixins/Dashboard'
  import filter from '@/mixins/Filter'
  import FilterSearchResetButton from '@/components/Buttons/FilterSearchResetButton'

  export default {
    name: 'Benutzerliste',
    components: {
      Navbar,
      HeadMenu,
      HeadMenuFilter,
      LoeschenModal,
      FilterSearchResetButton,
    },
    mixins: [page, dashboard, filter],
    props: {
      id: {
        type: String,
        required: false,
        default: null,
      },
    },
    store,
    data() {
      return {
        isAdmin: false,
        fields: [
          { key: 'selected', label: '' },
          {
            key: 'nachname',
            sortable: true,
            label: this.$t('global.surname'),
          },
          {
            key: 'vorname',
            sortable: true,
            label: this.$t('global.firstname'),
          },
          {
            key: 'loginName',
            sortable: true,
            label: this.$t('global.loginname'),
          },
          {
            key: 'benutzergruppe.bezeichnung',
            sortable: true,
            label: this.$t('global.usergroup'),
          },
          {
            key: 'aktiv',
            sortable: true,
            searchable: false,
            label: this.$t('global.active'),
            formatter: (value) => (value ? this.$t('global.yes') : this.$t('global.no')),
          },
        ],
      }
    },
    computed: {
      queryParams: function () {
        var params = {}

        params.nachname = this.setQueryParam(this.filters['nachname'])
        params.vorname = this.setQueryParam(this.filters['vorname'])
        params.loginName = this.setQueryParam(this.filters['loginName'])
        params.filterCount = this.setQueryParam(this.filters.count)

        return params
      },

      navbarTitel: function () {
        return this.$t('global.usermanagement')
      },
    },
    created() {
      this.initFilter('benutzer-liste', 'stammdaten/mitarbeiter/', true)
    },
    mounted() {
      this.$bus.$emit('searchWithFilter')
      if (this.berechtigungen.m_administration?.create) {
        this.isAdmin = true
      }
    },
    methods: {
      details(benutzer) {
        this.$router.push({
          name: 'benutzer',
          params: { id: benutzer.id, anzeige: 0 },
        })
      },

      loeschen() {
        Api.delete('stammdaten/mitarbeiter/', { data: this.selectedIds }).then(
          (response) => {
            this.schliesseLoeschenModal()

            this.listData = this.listData.filter(
              (v) => !response.data.success.includes(v.id)
            )
          }
        )
      },

      schliesseLoeschenModal() {
        $('#benutzer-loeschen-modal').modal('hide')
      },

      oeffneLoeschenModal() {
        $('#benutzer-loeschen-modal').modal('show')
      },

      sortingChanged(ctx) {
        this.sortDir = ctx.sortDesc
        this.sortField = ctx.sortBy
        this.resetLoading(this)
      },
    },
  }
</script>

<style></style>